import { IWPPostBase, WPPostBase, IModel } from "@/loader";

export type WPPostFormat = "" | "standard" | "aside" | "chat" | "gallery" | "link" | "image" | "quote" | "status" | "video" | "audio";

export interface IWPPost extends IWPPostBase {
	sticky?: boolean;
	format?: WPPostFormat;
	categories?: number[];
	tags?: number[];
}

export class WPPost extends WPPostBase implements IWPPost, IModel<IWPPost> {
	public sticky!: boolean;
	public format!: WPPostFormat;
	public categories!: number[];
	public tags!: number[];

	public constructor(data: IWPPost = {}) {
		super();
		this.load(data);
	}

	public load(data: IWPPost) {
		super.load(data);
		this.sticky = Boolean.orDefault(data.sticky);
		this.format = data.format || "";
		this.categories = Array.isArray(data.categories) ? data.categories.map(Number) : [];
		this.tags = Array.isArray(data.tags) ? data.tags.map(Number) : [];
	}

	public update(data: IWPPost) {
		super.update(data);
		if (data.sticky !== undefined) {
			this.sticky = Boolean.orDefault(data.sticky);
		}
		if (data.format !== undefined) {
			this.format = data.format || "";
		}
		if (data.categories !== undefined) {
			this.categories = Array.isArray(data.categories) ? data.categories.map(Number) : [];
		}
		if (data.tags !== undefined) {
			this.tags = Array.isArray(data.tags) ? data.tags.map(Number) : [];
		}
	}

	public restData() {
		let data = super.restData();
		return {
			...data,
			sticky: this.sticky,
			format: this.format,
			categories: this.categories,
			tags: this.tags,
		};
	}
}
